import { Component, inject } from '@angular/core';
import { faCheckDouble, faBan, faFlagCheckered } from '@fortawesome/pro-duotone-svg-icons';

import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-list-end-page-item',
  templateUrl: 'list-end-page-item.component.html',
  styleUrls: ['./list-end-page-item.component.scss', './_list-end-page-item-theme.component.scss']
})
export class ListEndPageItemComponent {
  faCheckDouble = faCheckDouble;
  faBan = faBan;
  faFlagCheckered = faFlagCheckered;

  surveyEditorService = inject(SurveyEditorService);

  onActivate(): void {
    this.surveyEditorService.selectEndPageScreen();

    this.surveyEditorService.surveyEditor$().form.get('useEndPageInd');
  }
}
